export default {"src":"/_next/static/media/conflictsManagement.8829f92d.svg","height":400,"width":425,"blurWidth":0,"blurHeight":0};